import dayjs from 'dayjs';
import { ComponentInternalInstance, getCurrentInstance, reactive, ref, Ref, toRefs } from '@vue/composition-api';
import i18n, { i18n_t } from '@/locales/i18n';
import { formatSize, formatType, getSpaceDirectory } from '@/renderer/scripts/utils/tools/index';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
export type detailItem = {
  group?: any;
  creationTime: string;
  modificationTime: string;
  name: string;
  originalPath: Array<string | number>;
  originalPathStr?: string;
  spaceStr: string;
  recycledItemId: string | number;
  remainingTime: string;
  removalTime: string;
  size?: string;
  type: string;
  spaceId: string;
  sensitiveWordName: string;
};
type Handler = {
  methods: {
    getDetailData: (item: SMH.ContentData) => void;
  };
  detailData: any;
  detailType: any;
  loading: Ref<boolean>;
};

export const detailType = {
  name: i18n_t('文件名'),
  creationPerson: i18n_t('创建人'),
  originalPathStr: i18n_t('文件路径'),
  spaceStr: i18n_t('空间位置'),
  type: i18n_t('类型'),
  size: i18n_t('大小'),
  creationTime: i18n_t('隔离时间'),
  virusName: i18n_t('安全扫描'),
};
export default function handleRowDetail(): Handler {
  const currComponent = getCurrentInstance() as ComponentInternalInstance;
  const vm = currComponent.proxy;
  const loading = ref(false);
  const detailData = ref();
  const methods = {
    async getDetailData(item: SMH.ContentData) {
      loading.value = true;
      const filePath = (item.path as string[]).join('/');
      const spaceOrgId = item?.group?.orgId || vm.$store.getters.orgId;
      try {
        const options = {
          path: filePath,
          spaceId: item.spaceId,
          spaceOrgId,
        };
        const { data } = await smh.userAPI.getDirectoryOrFileInfo(options);
        const pathStr = i18n_t('全部/{slot1}', { slot1: data.path?.slice(0, data.path?.length - 1).join('/') });
        const spaceStr = getSpaceDirectory(data);
        let virusName = '';
        // 根据suspiciousType字段判断是病毒还是可疑文件
        if (item.suspiciousType === 0) {
          virusName = data.virusType as string;
        } else if (item.suspiciousType === 1) {
          virusName = i18n_t('内容“{slot1}”触发敏感词', {
            slot1: data.sensitiveWordList?.join('，'),
          });
        }
        detailData.value = {
          ...data,
          type: formatType(data.type),
          size: data.type !== 'dir' ? this.formatSizeString(data.size as string) : '-',
          originalPathStr: pathStr,
          creationTime: dayjs(data.creationTime).format('YYYY-MM-DD HH:mm:ss'),
          suspiciousType: item.suspiciousType,
          virusName,
          spaceStr,
        };
        loading.value = false;
      } catch (err) {
        tips.error(err as MsgError);
      }
    },
    formatSizeString(itemSize: string) {
      const { size, unit } = formatSize(itemSize);
      return `${size} ${unit}`;
    },
  };
  return {
    methods,
    detailData,
    detailType,
    loading,
  };
}
